// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3njpL","messages":"Chat_messages__2DM2Z","dateDivider":"Chat_dateDivider__1qWkW"};